<!-- <div class="card-container">
  <mat-card class="shadow">
    <mat-card-title>Your Appointment</mat-card-title>
    <mat-card-content>
      <h3 *ngIf="appointmentDetails; else nodata">
        Your next appointment scheduled on {{ appointmentDetails.appotDate }} at
        {{ appointmentDetails.appotTime }}
      </h3>
      <ng-template #nodata><h3>No appointment scheduled</h3></ng-template>
    </mat-card-content>
  </mat-card>
  <mat-card class="shadow">
    <mat-card-title>Your Diet Plans</mat-card-title>
    <mat-card-content>
      <div class="pdf-buttons">
        <button
          mat-raised-button
          class="action-btn"
          (click)="pdfGenerator.printPdf(pdfContent)"
          [disabled]="this.userDetails.userUID === undefined"
        >
          Print Diet Plan <img [src]="printIcon" />
        </button>
        <button
          mat-raised-button
          class="action-btn"
          (click)="pdfGenerator.downloadPdf(pdfContent)"
          [disabled]="this.userDetails.userUID === undefined"
        >
          Download Diet Plan <img [src]="downloadIcon" />
        </button>
        <button
          mat-raised-button
          class="action-btn"
          (click)="pdfGenerator.viewPdf(pdfContent)"
          [disabled]="this.userDetails.userUID === undefined"
        >
          View Diet Plan <img [src]="eyeIcon" />
        </button>
      </div>
    </mat-card-content>
  </mat-card>
</div> -->
<div class="dashboard-container" *ngIf="client">
  <div class="welcome-section">
    <div class="welcome-text">
      <h1>Welcome to Crunch & Cheer</h1>
      <h2>With Dt. Asiya Ali</h2>
    </div>
  </div>
  <!-- Client Info Section -->
  <div class="client-info-section">
    <h2>Client Information</h2>
    <div class="client-details">
      <div class="info-item">
        <strong>Name:</strong> {{ client.firstName }} {{ client.lastName }}
      </div>
      <div class="info-item">
        <strong>Health Issues:</strong> {{ client.healthIssues || "None" }}
      </div>
      <div class="info-item">
        <strong>Package Booked:</strong> {{ client.package }}
      </div>
      <div class="info-item">
        <strong>Valid From:</strong> {{ client.packageStartDate | date }}
      </div>
      <div class="info-item">
        <strong>Valid Till:</strong> {{ client.packageEndDate | date }}
      </div>
      <div class="info-item">
        <strong>Sessions Completed:</strong>
        {{ appointmentDetails?.appotNo }}
      </div>
    </div>
  </div>

  <!-- Feature Cards Section -->
  <div class="feature-cards-section">
    <div class="feature-card" data-icon="diet">
      <i class="fas fa-clipboard-list"></i>
      <h3>Fill Diet Questionnaire</h3>
      <button [routerLink]="'/layout/diet-questionnaire'">Fill Now</button>
    </div>
    <div class="feature-card" data-icon="diet">
      <i class="fas fa-clipboard-list"></i>
      <h3>Schedule Appointment</h3>
      <button (click)="scheduleApt()">Schedule</button>
    </div>
    <div class="feature-card" data-icon="plan">
      <i class="fas fa-file-download"></i>
      <h3>Download Diet Plan</h3>
      <button
        mat-button
        mat-raised-button
        [disabled]="!pdfContent"
        (click)="pdfGenerator.downloadPdf(pdfContent, client?.firstName)"
      >
        Download
      </button>
    </div>
    <div class="feature-card" data-icon="receipt">
      <i class="fas fa-receipt"></i>
      <h3>Download Receipt</h3>
      <button disabled>Download</button>
    </div>
    <div class="feature-card" data-icon="yoga">
      <i class="fas fa-video"></i>
      <h3>Watch Yoga Videos</h3>
      <button disabled>Watch Now</button>
    </div>
    <div class="feature-card" data-icon="workout">
      <i class="fas fa-dumbbell"></i>
      <h3>Watch Workout Videos</h3>
      <button disabled>Watch Now</button>
    </div>
    <div class="feature-card" data-icon="message">
      <i class="fas fa-comments"></i>
      <h3>Message from Ms. Asiya</h3>
      <button disabled>Read Message</button>
    </div>
    <div class="feature-card" data-icon="recipes">
      <i class="fas fa-carrot"></i>
      <h3>Healthy Recipes</h3>
      <button disabled>View Recipes</button>
    </div>
  </div>
</div>
